<script>

    export let icon = "/static/info.svg"
    export let text= ""

    let popup

    function show() {
      popup.style.display = "block"
    }

    function close() {
      popup.style.display = "none"
    }



</script>


<span>
  <span
    class="button"
    on:click={show}
    on:touch={show}
    style="background-image:url( {icon} )"
  >
<!--<img src="/static/info.svg" style="height:30px"> -->
</span>

  <div class="popup" bind:this={popup}>
    <div
      class="everywhere"
      on:click={close}
      on:touch={close}
      on:scroll={close}
    ></div>
    <div>
      {text}
    </div>
  </div>

</span>





<style >

/* tooltip für weiterführende Infos */

.button {
  line-height: 1;
  padding-left: 1.1em;
  background-size: auto 100%;
  background-repeat: no-repeat;
  cursor:pointer;

  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.popup {
  display: none;
  position: absolute;

  font-size: 0.8rem;
  font-weight: normal;
  width: 50%; /*bezogen auf nächste position:relative Element */
  top:0;
  left:25%;
  background-color: white;
  /* text-align: center; */
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;
  padding: 10px;

  z-index: 1;
}

.everywhere {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}




</style>
